import type { FeatureKey, FeatureState, Me, Permission } from '@sm/api';
import { featureEnabled, featureVisible } from '@sm/core';

import { useMe } from './queries';

export function hasPermission(me: Pick<Me, 'permissions'> | undefined, p: Permission): boolean {
  return !!me?.permissions.includes(p);
}

/** `const can = useCan(); can('projects.write')` */
export function useCan(): (p: Permission) => boolean {
  const { data } = useMe();
  return (p) => hasPermission(data, p);
}

export function featureState(me: Pick<Me, 'features'> | undefined, key: FeatureKey): FeatureState {
  return (me?.features[key] as FeatureState | undefined) ?? 'off';
}

export { featureEnabled, featureVisible };
